// extracted by mini-css-extract-plugin
module.exports = {"container":"miOt36i1","chartTitleWrapper":"PkWuvZja"};